// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3seXX","modalForm":"UpgradeEpcsModal_modalForm__1v8TL","modalFooter":"UpgradeEpcsModal_modalFooter__3V-Zc"};